import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';

import { AppCol, AppLayoutTop, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ClaimsProvider from 'components/claimsBlock';
import { useAuth } from 'context/auth';
import { TabPanel } from 'devextreme-react';
import { SelectBox } from 'devextreme-react';

import { useGetCashFlowDocumentKindsQuery, useLazyGetCashFlowDetailQuery } from 'bus/cash';

import { CashFlowHistory } from './components';
import { TYPE_TEMPLATE_COMPONENTS } from './utils/templats';

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const CashFlowDetails: FC = () => {
  const { id, typeId } = useParams<{ id: string; typeId: string }>();
  const [type, setType] = useState<number | null>(null);
  const { getClaims }: any = useAuth();

  const isCanShowHistory = getClaims(['CanLookCashFlowHistories']);

  const tabs = useMemo(
    () => [
      {
        name: 'Основная информация',
        index: 0,
      },
      {
        name: 'История',
        index: 1,
        visible: isCanShowHistory && Boolean(id),
      },
    ],
    [isCanShowHistory, id],
  );

  const [activeTab, setActiveTab] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const { data: cashFlowDocumentKinds } = useGetCashFlowDocumentKindsQuery();
  const [cashFlowDocumentDetail] = useLazyGetCashFlowDetailQuery();

  const CustomForm = type !== null ? TYPE_TEMPLATE_COMPONENTS[type].template : null;

  const getDetail = useCallback(async () => {
    const result = await cashFlowDocumentDetail({ id });
    setType(result.data?.documentKind || 0);
  }, [cashFlowDocumentDetail, id]);

  useEffect(() => {
    if (id) getDetail();
    if (typeId) {
      setType(+typeId);
    }
  }, [getDetail, id, typeId]);

  return (
    <div>
      {!id && (
        <>
          <AppLayoutTop title="Движения по кассе" />
          <div className="dx-card" style={{ width: 350 }}>
            <AppRow>
              <AppCol col={12}>
                <AppFiledBox label="Тип" labelTop>
                  <SelectBox
                    stylingMode="underlined"
                    items={cashFlowDocumentKinds}
                    displayExpr="name"
                    valueExpr="id"
                    value={type}
                    onItemClick={(e) => setType(e.itemData.id)}
                  />
                </AppFiledBox>
              </AppCol>
            </AppRow>
          </div>
        </>
      )}

      {type !== null && TYPE_TEMPLATE_COMPONENTS[type] && (
        <>
          <TabPanel
            height="auto"
            dataSource={tabs}
            selectedIndex={selectedIndex}
            onOptionChanged={(e) => {
              if (e.name === 'selectedIndex') {
                setSelectedIndex(e.value);
              }
            }}
            itemTitleRender={itemTitleRender}
            animationEnabled={false}
            onSelectionChanged={(e) => setActiveTab(e.addedItems![0].index)}
          />
          {activeTab === 0 && (
            <ClaimsProvider claimsBlock={TYPE_TEMPLATE_COMPONENTS[type].claims}>
              <CustomForm id={id} />
            </ClaimsProvider>
          )}
          {activeTab === 1 && <CashFlowHistory />}
        </>
      )}
    </div>
  );
};

export default CashFlowDetails;
